import { Outlet, useParams } from "react-router-dom";
import PageTitle from "../components/common/PageTitle";
import { useCallback, useEffect, useState } from "react";
import { useAppContext } from "../providers/ProviderAppContainer";
import Loading from "../components/common/Loading";
import NoContent from "../components/common/NoContent";
import PromoDialog from "../components/common/PromoDialog";

export default function Subjects() {
    const [course, setCourse] = useState();
    const [loading, setLoading] = useState();
    const [error, setError] = useState();
    const [promoDialogContents, setPromoDialogContents] = useState();
    const { requestAPI } = useAppContext();

    const { courseId } = useParams();

    useEffect(() => {
        if (courseId)
            requestAPI({
                requestPath: `courses/${courseId}`,
                requestMethod: "GET",
                setLoading: setLoading,
                onRequestStart: setError,
                onRequestFailure: setError,
                onResponseReceieved: (course, responseCode) => {
                    if (course && responseCode === 200) {
                        setCourse(course);
                    } else {
                        setError("Couldn't load Course");
                    }
                },
            });
    }, [courseId, requestAPI]);

    useEffect(() => {
        if (!courseId) return;

        requestAPI({
            requestPath: `dialog-contents/courses/${courseId}`,
            requestMethod: "GET",
            onResponseReceieved: (contents, code) => {
                if (code === 200 && Array.isArray(contents)) {
                    setPromoDialogContents(contents);
                }
            },
        });
    }, [courseId, requestAPI]);

    const onContentSeen = useCallback(
        (content_id) => {
            requestAPI({
                requestPath: "dialog-contents/views/courses",
                requestMethod: "POST",
                requestPostBody: { content_id },
                parseResponseBody: false,
                onResponseReceieved: (_, code) => {
                    if (code === 204) {
                        setPromoDialogContents((prev) => {
                            const slide = prev?.find((c) => c.id === content_id);
                            if (!slide || slide.viewed) return prev;
                            return prev.map((c) => (c.id === content_id ? { ...c, viewed: true } : c));
                        });
                    }
                },
            });
        },
        [requestAPI],
    );

    return (
        <div className="flex flex-column h-full ">
            <PageTitle title={course?.title} />

            {loading ? (
                <Loading message="Loading Course" />
            ) : error ? (
                <NoContent error={error} />
            ) : course ? (
                <Outlet context={{ course, setCourse }} />
            ) : (
                <NoContent error={"Course Not Found"} />
            )}

            <PromoDialog contents={promoDialogContents} onContentSeen={onContentSeen} />
        </div>
    );
}
